module.exports = __webpack_public_path__ + "img/vip-crown-2-fill.553d870c.svg";